// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__tlqkX","footer":"ModalInfo_footer__-xo7X"};